// Modules
import React from 'react';
import 'react-day-picker/lib/style.css';
// @ts-ignore
import {LocalizationContext} from 'react-localize';

// Styles
import "./CalendarLegend.sass";

// Components
import MvModal from '../MvModal';
import { EXEC_MODE } from 'cfg';
import { ReactAppMode } from 'Interfaces/ReactAppModes';

type Props = {
openModal: boolean,
showModal: () => void

}
class MvCalendarLegend extends React.Component<Props, {}> {


    render() {
        const {localize} = this.context;

        return (
            <>
              <MvModal
              toggleModal={this.props.showModal}
              openModal={this.props.openModal}>
                  <>{localize("static.content.outside-booking-window")}</>
                  </MvModal>
            <div className="calendar-legend-table">
                <div className="calendar-legends">
                    <div className="availability-box new-available-color"/>
                    <div className="availability-class-label">
                        {localize("static.content.available-check-in")}
                    </div>
                </div>
                <div className="calendar-legends">
                    <div className="availability-box unavailable-color"/>
                    <div className="availability-class-label">
                        {localize("static.content.unavailable-check-in")}
                    </div>
                </div>
                <div className="calendar-legends">
                    <div className="availability-box outside-booking-color"/>
                        {
                            [ReactAppMode.VCAP,ReactAppMode.LOCAL].includes(EXEC_MODE) &&

                            // commenting out div that would popup the modal. we'll use this for future use when the popup is fully developed. navigate to existing page for now
                            // <div aria-label='outside booking window button'
                            //     style={{ textDecoration: 'underline', cursor: 'pointer' }}
                            //     onClick={this.props.showModal} className="availability-class-label">
                            //     {localize("static.content.outside-booking-window")}
                            // </div>

                            <a href="/timeshare/mvco/ownerresources/inventorycalendar" className="availability-class-label">{localize("static.content.outside-booking-window")}</a>
                        }

                    {[ReactAppMode.VOA].includes(EXEC_MODE) && <a href="/timeshare/mvco/ownerresources/inventorycalendar" className="availability-class-label">{localize("static.content.outside-booking-window")}</a>}
                    
                </div>
            </div>
            </>
        );
    }
}

MvCalendarLegend.contextType = LocalizationContext;

export default MvCalendarLegend;
